export default __webpack_public_path__ + "static/media/what-we-do-desktop-ellipse-medium.4d1e2d82.svg";